export const APPLE_CONST = {
  // query param on /callback whose value (the post-Auth0 destination URL) tells us
  // we are mid-Apple-News flow and should run the Apple subscription check
  redirectUriParam: 'redirect_uri',
  // substring inside the redirect_uri / auth_redirect that identifies the Apple News flow
  appleFlowIdentifier: 'applenews',
  // temporary marker we add to the destination URL pre-Auth0 and strip post-Auth0
  postAppleLoginParam: 'post-apple-login',
  // query param appended to the final Apple News redirect with the encrypted uuid
  accessTokenParam: 'access_token',
};
